module.exports = __webpack_public_path__ + "static/sport/title.a6fbaa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cart/title.png
// module id = bSA0
// module chunks = 0